import React from 'react'
import Nav from '../components/nav/nav'
import ForumSubmissions from '../components/ForumSubmissions/ForumSubmissions'

const forum = () => {
    return (
      <div>
        <Nav/>
        <ForumSubmissions/>
      </div>
    )
  }

  export default forum